import VueRouter from 'vue-router'
import Vue from 'vue';

Vue.use(VueRouter);



const routes = [
  {
    path: '/Booking/:PropertyName/:PropertyCode',
    name: 'Booking',
    component: () =>
      import(/* webpackChunkName: "DefaultView" */ "./components/Body.vue"),
    props: true
  },
  {
    path: '/Booking/:PropertyName/:PropertyCode/:Type/:OrderCode',
    name: 'Confirmation',
    component: () =>
      import(/* webpackChunkName: "ConfirmationView" */ "./components/Body.vue"),
    props: true
  },
  {
    path: '/Booking/:PropertyName/:PropertyCode/Confirmation/:OrderCode',
    name: 'BookingDetails',
    component: () =>
      import(/* webpackChunkName: "BookingDetailsView" */ "./components/Booking/BookedDetails.vue"),
    props: true
  },
  {
    path: '/TestPayment',
    name: 'Test',
    component: () =>
      import(/* webpackChunkName: "BookingDetailsView" */ "./components/Test.vue"),
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
})

router.beforeEach((to, from, next) => {
  console.log(to, 'to');
  console.log(from, 'from');
  next();
})


export default router
